import { SectionHeading } from "client/packages/commerce/components/ui/textStyles"
import { useState } from "react"
import { FormattedMessage } from "react-intl"
import styled from "styled-components"

import ReportForm from "./ReportForm"
import ReportSuccess from "./ReportSuccess"

const MainWrapper = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: column;
`

const Title = styled(SectionHeading)`
  font-size: 1.57rem;
  color: ${(props) => props.theme.colors.darkMed};
`

const ReportView = () => {
  const [isFormComplete, setIsFormComplete] = useState<boolean>(false)

  return (
    <MainWrapper>
      <Title>
        <FormattedMessage
          id="report.title"
          defaultMessage="Report Stage"
        />
      </Title>
      {isFormComplete ? (
        <ReportSuccess />
      ) : (
        <ReportForm onSuccess={() => setIsFormComplete(true)} />
      )}
    </MainWrapper>
  )
}

export default ReportView
